export default "__VITE_ASSET__DDy7PKz8__"